export const constants = {
  colors: {
    bit: "#3989a6",
    bitTransparent: "rgba(57,137,166,0.3)", // #3989a6
    essence: "#96b94b",
    essenceTransparent: "rgba(150,185,75,0.3)", // #96b94b
    grey: "#202123",
    orange: "#e89b30",
    white: "white",
    almostWhite: "#dadada",
  },
  headerHeight: window.innerWidth <= 700 ? 84 : 96,
};
